/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Route, Switch, Redirect } from "react-router";
// redux
import { useSelector } from 'react-redux';
// material
import { Division, InContentMessage } from "@insticator/insticator-ui";
// pages
import BillingPage from "./billing/billing";
import CompanyPage from "./company/company";
import HelpPage from "./help/help";
import UsersPage from './users/users';
import InsticatorPlatformPage from "./insticatorplatform/insticatorplatform";
import AccountPage from './account/account';
// styles
import injectSheet from "react-jss";
import DeveloperToolsPage from "./developertools/developer_tools";


/* ========== ~~~~~~~~~~ SETTINGS DIVISION ~~~~~~~~~~ ========== */
const SettingsDivision = props => {

  return (
    <Division name={'settings'}>
        <Switch>
            <Route exact path='/dashboard/settings' render={() => <Redirect to={'dashboard/settings/billing'} />} />
            <Route path='/dashboard/settings/billing' component={BillingPage} />
            <Route path='/dashboard/settings/company' component={CompanyPage} />
            <Route path='/dashboard/settings/developerTools' component={DeveloperToolsPage} />
            <Route path='/dashboard/settings/help' component={HelpPage} />
            <Route path='/dashboard/settings/insticatorplatform' component={InsticatorPlatformPage} />
            <Route path='/dashboard/settings/users' component={UsersPage} />
            <Route path='/dashboard/settings/account' component={AccountPage} />
            <Redirect to='/error/404' />
        </Switch>
    </Division>
  )
}
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default SettingsDivision;